/**
 * Teen Patti 20-20 — the crowd. FIREWALLED: imports nothing from the money
 * path; everything is a PURE FUNCTION of (tableSeed, roundNo) so every viewer
 * sees the same theatre (plan §5.4). Real per-side pools are NEVER shown (P9).
 */
import { mulberry32, mix } from '../aviator/prng';

const NAMES = [
  'Ravi', 'Priya', 'Manish', 'Farhan', 'Amrutha', 'Vikram', 'Sana', 'Deepak',
  'Kavya', 'Arjun', 'Neha', 'Rohit', 'Ishaan', 'Pooja', 'Salman', 'Anita',
  'Tarun', 'Meera', 'Zoya', 'Karan', 'Bhavna', 'Nikhil', 'Rehan', 'Simran',
];
export const mask = (n: string) => n.slice(0, 2) + '**' + n.slice(-1);
const STAKES = [10, 50, 100, 100, 100, 500, 500, 1000, 5000];

export type FakeBet = { id: string; name: string; side: 'a' | 'b'; stake: number; /** seconds into the window when the chip lands */ at: number };

/** 18–46 fake bettors per round, arriving through the 15s window */
export function crowdFor(tableSeed: number, roundNo: number): FakeBet[] {
  const rnd = mulberry32(mix(tableSeed, roundNo));
  const n = 18 + Math.floor(rnd() * 29);
  const out: FakeBet[] = [];
  for (let i = 0; i < n; i++) {
    out.push({
      id: `f${roundNo}-${i}`,
      name: mask(NAMES[Math.floor(rnd() * NAMES.length)]),
      side: rnd() < 0.5 ? 'a' : 'b',
      stake: STAKES[Math.floor(rnd() * STAKES.length)],
      at: rnd() * 13.5,
    });
  }
  return out.sort((a, b) => a.at - b.at);
}

export function seatsFor(tableSeed: number, roundNo: number): number {
  const rnd = mulberry32(mix(tableSeed ^ 0xA11, roundNo));
  return 90 + Math.floor(rnd() * 220);
}
